module.exports = __webpack_public_path__ + "b07d2610274acfba7577c26148970a33.png";


//////////////////
// WEBPACK FOOTER
// ./public/pic3@2x.png
// module id = 210
// module chunks = 1